// path files
import auth from "./document/path/auth.yaml";
import file from "./document/path/file.yaml";
import folder from "./document/path/folder.yaml";
import link from "./document/path/link.yaml";
import thumbnail from "./document/path/thumbnail.yaml";
import viewer from "./document/path/viewer.yaml";
import webhook from "./document/path/webhook.yaml";
import manager from "./document/path/manager.yaml";
import sso from "./document/path/sso.yaml";

// schema files
import webhookSchema from "./document/schemas/webhook.yaml";
import commonSchema from "./document/schemas/common.yaml";

// openapi files
import requests from "./document/openapi/requests.yaml";
import responseError from "./document/openapi/response.error.yaml";
import responses from "./document/openapi/responses.yaml";

const pathFileImport = (type) => {
  let pathFile;
  switch (type) {
    case "auth":
      pathFile = auth;
      break;
    case "folder":
      pathFile = folder;
      break;
    case "file":
      pathFile = file;
      break;
    case "link":
      pathFile = link;
      break;
    case "thumbnail":
      pathFile = thumbnail;
      break;
    case "viewer":
      pathFile = viewer;
      break;
    case "sso":
      pathFile = sso;
      break;
    case "webhook":
      pathFile = webhook;
      break;
    case "manager":
      pathFile = manager;
      break;
  }
  return pathFile;
};

const schemaFileImport = (type) => {
  let schemaFile;
  switch (type) {
    case "webhook":
      schemaFile = webhookSchema;
      break;
    case "common":
      schemaFile = commonSchema;
      break;
  }
  return schemaFile;
};

const modelParser = (document, type) => {
  const model = document.tags.find((item) => item.name === type);
  let modelUrlArr = model.description.split('"')[1].split("/");
  modelUrlArr = modelUrlArr.filter((item) => item !== "#");
  let ref = document;
  modelUrlArr.forEach((item, index) => {
    ref = ref[item];
  });

  if (!ref["$ref"].includes(type)) return;
  const refKey = type;
  const refValue = ref["$ref"];

  let filename = refValue.split("/");
  filename = filename.find((item) => item.includes("yaml"));
  filename = filename.split(".")[0];

  const schemaFile = schemaFileImport(filename);
  return schemaFile[refKey];
};

export const userParser = function (document, type) {
  if (!document.hasOwnProperty("paths")) return [];
  const models = document["x-tagGroups"].filter(
    (item) => item.name === "Models"
  );
  models[0].tags.forEach((item) => {
    if (item === type) {
      return modelParser(document, type);
    }
  });

  type = type.replace(/ /gi, "").toLowerCase();

  const { paths } = document;

  const results = [];
  for (let url in paths) {
    if (url.includes(type)) {
      const pathsValues = {};
      pathsValues.url = url;
      const urlKey = paths[url]["$ref"];
      urlKey && (pathsValues.refKey = urlKey.split("#/")[1]);
      results.push(pathsValues);
    }
  }

  const refFile = pathFileImport(type);
  for (let result of results) {
    result.refValue = refFile[result.refKey];
  }

  // parameters 제외.
  results.forEach((item) => {
    item.methods = Object.keys(item.refValue).filter(
      (item) => item !== "parameters"
    );
  });
  return results;
};

export const managerParser = function (document, type) {
  if (!document.hasOwnProperty("paths")) return [];
  type = type.replace(/ /gi, "").toLowerCase();

  const { paths } = document;
  const results = [];

  for (let url in paths) {
    if (url.includes(type)) {
      const pathsValues = {};
      pathsValues.url = url;
      const urlKey = paths[url]["$ref"];
      urlKey && (pathsValues.refKey = urlKey.split("#/")[1]);
      results.push(pathsValues);
    }
  }
  if (type !== "auth") {
    type = "manager";
  }
  const refFile = pathFileImport(type);

  for (let result of results) {
    result.refValue = refFile[result.refKey];
  }

  // parameters 제외.
  results.forEach((item) => {
    item.methods = Object.keys(item.refValue).filter(
      (item) => item !== "parameters"
    );
  });

  return results;
};

export const docParser = function (document, keys) {
  let values = [];
  for (let key of keys) {
    if (document[key]) {
      values.push(document[key]);
    }
  }
  return values;
};

export const getXTags = function (document) {
  if (!document.hasOwnProperty("x-tagGroups")) return [];
  const tags = document["x-tagGroups"].map((item) => item.tags);
  return tags.flat();
};

export const getTags = function (document) {
  if (!document.hasOwnProperty("tags")) return [];
  return document.tags.map((tag) => tag.name);
};

export const refParser = function (document, ref) {
  // 배열 ref 치환.
  if (Array.isArray(ref)) {
    ref.forEach((item, index) => {
      if (item["$ref"]) {
        const key = item["$ref"].split("#/")[1];
        ref[index] = document[key];
      }
    });
  } else {
    // 단일 ref 데이터만 가져옴.
    const key = ref["$ref"].split("#/")[1];
    ref = document[key];
    return ref;
  }
  return ref;
};

export const maxDepth = function (obj) {
  let res = JSON.stringify(obj).replace(/[^{|^}]/g, "");
  while (/}{/g.test(res)) {
    res = res.replace(/}{/g, "");
  }
  return res.replace(/}/g, "").length;
};

export const recursiveParser = function (obj, depth, document) {
  const target = "$ref";
  if (!depth || typeof obj !== "object") {
    return obj;
  }
  // 객체일때.
  if (!Array.isArray(obj)) {
    let keys = Object.keys(obj);
    keys.forEach((item) => {
      if (typeof item === "string" && item === target) {
        let refSplit = obj[item].split("#/");
        let refKey = refSplit[1];
        obj[item] = document[refKey];
        Object.entries(obj[item]).forEach((el) => {
          obj[el[0]] = el[1];
          delete obj[item];
        });
      } else {
        return recursiveParser(obj[item], depth - 1, document);
      }
    });
  } else {
    obj.forEach((item) => {
      // item　객체일때.
      return recursiveParser(item, depth - 1, document);
    });
  }
  return obj;
};

export const searchContentParser = function (content, userDoc, managerDoc) {
  if (content === null) return [];
  let userContentParser = documentSearch(content, userDoc);
  let managerContentParser = documentSearch(content, managerDoc);

  const findContentLength =
    userContentParser.length + managerContentParser.length;
  const findContentArr = {
    userContentParser,
    managerContentParser,
    findContentLength,
  };

  return findContentArr;
};

const documentSearch = function (content, doc) {
  if (!doc.paths) return;
  // Home 컴포넌트와의 참조관계 때문에 깊은복사 이용.
  const paths = JSON.parse(JSON.stringify(doc.paths));
  let keys = Object.keys(paths);
  // ref 치환.
  keys.forEach((key) => {
    const url = paths[key]["$ref"];
    if (url) {
      const urlKey = url.split("#/")[1];
      let type = url.split("/");
      type = type.find((key) => key.includes("yaml"));
      type = type.split(".")[0];
      const file = pathFileImport(type);
      file[urlKey]["parameters"] && delete file[urlKey]["parameters"];
      paths[key] = file[urlKey];
    }
  });
  // searching
  let findArr = [];
  keys.forEach((url) => {
    const methods = Object.keys(paths[url]);
    methods.forEach((method) => {
      let ct = content.toLowerCase();
      const tagsLower = paths[url][method].tags[0].toLowerCase();
      if (
        paths[url][method].description.includes(content) ||
        paths[url][method].summary.includes(content) ||
        tagsLower.includes(ct)
      ) {
        findArr.push({
          method,
          summary: paths[url][method].summary,
          description: paths[url][method].description,
          tags: paths[url][method].tags[0],
        });
      }
    });
  });

  return findArr;
};

export const webhookDescription = function (doc) {
  console.log(doc.tags);
};
